export function ConvertStringWithoutValueToDefault(
  string?: string | number | undefined | null,
) {
  return string ? String(string) : "--";
}
